import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-1"
}

import { computed } from 'vue';

export interface IProps {
  exibir: boolean
  titulo?: string
  mensagem: string
  detalhes?: string
  textoSim?: string
  textoNao?: string
  tipo?: 'warning' | 'danger' | 'success' | 'info' | 'question'
  botaoFechar?: boolean
  fecharSeClicouFora?: boolean
  processando?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    exibir: { type: Boolean },
    titulo: { default: 'Confirmação' },
    mensagem: {},
    detalhes: {},
    textoSim: { default: 'Sim' },
    textoNao: { default: 'Não' },
    tipo: { default: 'question' },
    botaoFechar: { type: Boolean, default: true },
    fecharSeClicouFora: { type: Boolean, default: true },
    processando: { type: Boolean, default: false }
  },
  emits: ["resposta", "fechou"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Computed para ícones e classes baseados no tipo
const icone = computed(() => {
  const icones = {
    warning: 'fa fa-exclamation-triangle text-warning',
    danger: 'fa fa-exclamation-circle text-danger',
    success: 'fa fa-check-circle text-success',
    info: 'fa fa-info-circle text-info',
    question: 'fa fa-question-circle text-primary'
  }
  return icones[props.tipo]
})

const classeSimBtn = computed(() => {
  const classes = {
    warning: 'btn btn-warning',
    danger: 'btn btn-danger',
    success: 'btn btn-success',
    info: 'btn btn-info',
    question: 'btn btn-primary'
  }
  return classes[props.tipo]
})

const iconeSimBtn = computed(() => {
  const icones = {
    warning: 'fa fa-check',
    danger: 'fa fa-trash',
    success: 'fa fa-check',
    info: 'fa fa-info',
    question: 'fa fa-check'
  }
  return icones[props.tipo]
})

function responder(confirmou: boolean) {
  if (props.processando) return
  
  emit('resposta', confirmou)
  emit('fechou')
}

function fecharSeClicouFora() {
  if (props.fecharSeClicouFora && !props.processando) {
    responder(false)
  }
}

// Impedir scroll do body quando modal estiver aberto
document.body.style.overflow = props.exibir ? 'hidden' : 'auto'

return (_ctx: any,_cache: any) => {
  return (__props.exibir)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: fecharSeClicouFora
      }, [
        _createElementVNode("div", {
          class: "modal-dialog",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h5", _hoisted_3, [
                _createElementVNode("i", {
                  class: _normalizeClass([icone.value, "me-2"])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(__props.titulo), 1)
              ]),
              (__props.botaoFechar)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn-close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (responder(false)))
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(__props.mensagem), 1),
              (__props.detalhes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.detalhes), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (responder(false))),
                disabled: __props.processando
              }, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(__props.textoNao), 1)
              ], 8, _hoisted_8),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn-sm", classeSimBtn.value]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (responder(true))),
                disabled: __props.processando
              }, [
                (__props.processando)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: _normalizeClass([iconeSimBtn.value, "me-1"])
                    }, null, 2)),
                _createTextVNode(" " + _toDisplayString(__props.textoSim), 1)
              ], 10, _hoisted_9)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})